import { IHttpService } from "../HttpService";
import Fact, { IFact } from "../../model/evaluation/Fact";

export interface IFactService {
  getFacts(): Promise<IFact[]>;
  createFact(fact: IFact): Promise<any>;
  updateFact(fact: IFact): void;
}

const FactService = (httpService): IFactService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/";
  const _basePath = "facts";

  const FactMapper = (json = []) => {
    return json.map(Fact);
  };

  return {
    async getFacts() {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return FactMapper(responseJSON);
    },

    async createFact(fact: IFact) {
      const path = _http.buildPath(_baseUrl, _basePath);
      const response = await _http.post(path, {
        params: fact,
        form: true
      });
      return _http.toText(response);
    },

    async updateFact(fact: IFact) {
      const path = _http.buildPath(_baseUrl, _basePath, fact.id.toString());
      const response = await _http.put(path, {
        params: fact,
        form: true
      });
      return _http.toText(response);
    }
  };
};

export default FactService;
